module.exports = __webpack_public_path__ + "img/120.7.a057d79d.png";